import { Station } from '@app/core/types/stations';
import { BreadcrumbItem } from '@mi-front/ui';
import { Box } from '@mui/material';
import { StationAvatar } from './StationAvatar';

interface StationBreadcrumbLabelProps {
  readonly station: Pick<Station, 'id' | 'name' | 'logoUrl'>;
}

/**
 * Station name with avatar for use as breadcrumb content.
 */
export function StationBreadcrumbLabel({ station }: StationBreadcrumbLabelProps) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
      <StationAvatar stationId={station.id} station={station} size={16} />
      {station.name}
    </Box>
  );
}

/**
 * Builds a breadcrumb item that links to a station list with avatar + name.
 */
export function createStationBreadcrumbItem(
  station: Pick<Station, 'id' | 'name' | 'logoUrl'>,
  href: string,
): BreadcrumbItem {
  return {
    content: <StationBreadcrumbLabel station={station} />,
    href,
  };
}
